import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { Usuario } from 'src/app/models/usuario-login';

@Component({
  selector: 'app-list-config-laudo-union',
  templateUrl: './list-config-laudo-union.component.html',
  styleUrls: ['./list-config-laudo-union.component.scss']
})
export class ListConfigLaudoUnionComponent implements OnInit {

  usuario: Usuario;
  listaResultado = [];
  total = 0;
  tableLoading = true;
  params = {
    sorting: {
      nome: 'desc',
      descricao: ''
    },
    per_page: 10,
    page: 1,
    data: new Date()
  };

  constructor(private loginService: LoginService, private laudoUnionService: LaudoUnionService, private modalMsgService: ModalMsgService, private modalService: NgbModal) {
    this.loginService.getLogIn().pipe(first()).subscribe(u => this.usuario = u);
    this.getListaResultado();
  }

  ngOnInit() { }

  // delete(config) {
  //   this.laudoUnionService.excluirConfigLaudo(config.id).then(r => {
  //     this.getListaResultado();
  //   });
  // }

  delete(config) {
    this.modalMsgService.justificativa('Remover configuração de laudo')
      .then(justificativa => {
        this.laudoUnionService.excluirConfigLaudo(config.uuid, justificativa)
          .then(() => this.getListaResultado())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover configuração de laudo', '', 'danger'))
      }).catch(e => e);
      //catch somente para não subir a exceção que ocorre ao cancelar ou dar dismiss no modal ;)
  }

  getListaResultado() {
    this.tableLoading = true;
    this.laudoUnionService.getListaConfigLaudo(this.params).then(r => {
      this.listaResultado = r.lista;
      this.total = r.total;
    }).finally(() => this.tableLoading = false);
  }

  setOrder() {
    this.getListaResultado();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.getListaResultado();
  }

  pageChange() {
    this.getListaResultado();
  }

}
